<template>
    <div style="position: relative;left: 0;top: 0;bottom: 0;right: 0;width:100%;">
        <div class="left-head">
            <el-row>
                <el-col :span="24">用户信息</el-col>
            </el-row>
        </div>
        <div class="left">
            <div class="left-flex">
            <el-row>
                <el-col :span="6" class="userInfo">
                    用户名称：
                </el-col>
                <el-col :span="18">
                    <span class="userInfoValue" v-text="customerName"></span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" class="userInfo">
                    用户编号：
                </el-col>
                <el-col :span="18">
                    <span class="userInfoValue" v-text="customerCode"></span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" class="userInfo">
                    用户地址：
                </el-col>
                <el-col :span="18">
                    <span class="userInfoValue" v-text="customerAddr"></span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" class="userInfo">
                    联系人：
                </el-col>
                <el-col :span="18">
                    <span class="userInfoValue" v-text="customerContactPerson"></span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" class="userInfo">
                    手机号码：
                </el-col>
                <el-col :span="18">
                    <span class="userInfoValue" v-text="customerMobile"></span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" class="userInfo">
                    电子邮箱：
                </el-col>
                <el-col :span="18">
                    <span class="userInfoValue" v-text="customerEmail"></span>
                </el-col>
            </el-row>
            </div>
        </div>
        <div class="right-head">
            <el-row>
                <el-col :span="24">充值</el-col>
            </el-row>
        </div>
        <div class="right">
            <div class="right-flex">
                <el-row :gutter="5">
                    <el-col :span="3" class="title-card">选择仪表：</el-col>
                    <el-col :span="5">
                        <el-select v-model="meterId" placeholder="请选择仪表" style="width:100%;">
                            <el-option
                                    v-for="item in meters"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="18" class="meter">
                        <div>
                            <el-row :gutter="5">
                                <el-col :span="12" class="userInfo">
                                    仪表编号：
                                    <span class="userInfoValue" v-text="meterCode"></span>
                                </el-col>
                                <el-col :span="12" class="userInfo">
                                    能耗类型：
                                    <span class="userInfoValue" v-text="meterType"></span>
                                </el-col>
                            </el-row>
                            <el-row :gutter="5">
                                <el-col :span="12" class="userInfo">
                                    当前余额：
                                    <span v-text="meterBalance" class="userInfoValue" style="color: red;"></span>
                                </el-col>
                                <el-col :span="12" class="userInfo">
                                    抄表时间：
                                    <span class="userInfoValue" v-text="meterReadingTime"></span>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :span="3" class="title-card">充值金额：</el-col>
                    <el-col :span="3"><el-radio v-model="money" border label="50">50元</el-radio></el-col>
                    <el-col :span="3" :offset="1"><el-radio v-model="money" border label="100">100元</el-radio></el-col>
                    <el-col :span="3" :offset="1"><el-radio v-model="money" border label="200">200元</el-radio></el-col>
                    <el-col :span="3" :offset="1"><el-radio v-model="money" border label="500">500元</el-radio></el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :span="3" :offset="3"><el-radio v-model="money" border label="1000">1000元</el-radio></el-col>
                    <el-col :span="3" :offset="1"><el-radio v-model="money" border label="2000">2000元</el-radio></el-col>
                    <el-col :span="3" :offset="1"><el-radio v-model="money" border label="5000">5000元</el-radio></el-col>
                    <el-col :span="3" :offset="1"><el-radio v-model="money" border label="10000">10000元</el-radio></el-col>
                </el-row>

                <el-row :gutter="5">
                    <el-col :span="3" class="title-card">付款方式：</el-col>
                    <el-col :span="4">
                        <el-radio v-model="payType" border label="wxpay"><svg-icon icon-class="微信充值"></svg-icon> 微信支付</el-radio>
                    </el-col>
                    <el-col :span="4">
                        <el-radio v-model="payType" border label="alipay"><svg-icon icon-class="支付宝"></svg-icon> 支付宝</el-radio>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :span="3" class="title-card">付款金额：</el-col>
                    <el-col :span="8">
                        <el-input v-model="money" class="amount-input">
                            <template slot="append">元</template>
                        </el-input>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col  :offset="3" :span="8">
                        <el-button @click="pay" type="primary" style="width: 70%;" :loading="fullscreenLoading">充值</el-button>
                    </el-col>
                </el-row>
            </div>
        </div>
        <el-dialog
                :title="payTypeName"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :show-close="false"
                width="350px"
                top="2vh"
                center>
            <el-row :gutter="5">
                <el-col :span="24">
                    <div class="qrcode_box">
                        <canvas class="qrcode"></canvas>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col class="dialogInfo" :offset="4" :span="6">仪表编号:</el-col>
                <el-col class="dialogInfo" :span="14" v-text="meterCode"></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col class="dialogInfo" :offset="4" :span="6">仪表名称:</el-col>
                <el-col class="dialogInfo" :span="14" v-text="meterName"></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col class="dialogInfo" :offset="4" :span="6">能耗类型:</el-col>
                <el-col class="dialogInfo" :span="14"><span v-text="meterType"></span></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col class="dialogInfo" :offset="4" :span="6">当前余额:</el-col>
                <el-col class="dialogInfo" :span="14"><span v-text="meterBalance"></span></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col class="dialogInfo" :offset="4" :span="6">抄表时间:</el-col>
                <el-col class="dialogInfo" :span="14"><span v-text="meterReadingTime"></span></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col class="dialogInfo" :offset="4" :span="6">订单号:</el-col>
                <el-col class="dialogInfo" :span="14" v-text="tradeNo"></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col class="dialogInfo" :offset="4" :span="6">充值金额:</el-col>
                <el-col class="dialogInfo" :span="14"><span v-text="moneyStr"></span> 元</el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col class="dialogInfo" :offset="4" :span="6">应付金额:</el-col>
                <el-col class="dialogInfo" :span="14"><span v-text="realMoney"></span> 元</el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">支付完成？点击关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
  import {aliPay,wxPay,rechargeResult} from '@/api/inquiryMachineRecharge'
  import {queryCustomerById} from '@/api/customerUser'
  import {getMetersByUser} from '@/api/Meter'
  import {format} from '@/utils/time'
  import { WS } from '@/utils/ws'
  import {uuidWithoutLine} from "@/utils/uuid"
  import {sendMail} from '@/api/mail'
  import QRCode from 'qrcode'
  export default {
    name: "pay",
    data() {
      return {
        customerName:"",
        customerCode:"",
        customerMobile:"",
        customerAddr:"",
        customerEmail:"",
        customerContactPerson:"",
        meters:[],
        meterName:"",
        meterId:"",
        meterCode:"",
        meterType:"",
        meterBalance:"",
        meterReadingTime:"",
        meterStatus:true,
        money:"50",
        moneyStr: "",
        realMoney: "",
        payType:"wxpay",
        fullscreenLoading: false,
        qrSrc:"",
        payTypeName:"",
        dialogVisible:false,
        tradeNo:"",
        customerId:this.$store.getters.customerId,
        customerUserId:this.$store.getters.userId,
        rechargeSubscribe: {}
      }
    },
    watch: {
      meterId(val) { //监听仪表选择框
        for(let i in this.meters){
          let meter=this.meters[i]
          if(meter.id==val){
            if(meter.meterConnectionStatus!==null&&meter.meterConnectionStatus!==undefined&&meter.meterConnectionStatus!==""){
              if(meter.meterConnectionStatus==1){
                this.meterStatus=true
              }else if(meter.meterConnectionStatus==0){
                this.meterStatus=false
              }
            }else{
              this.meterStatus=false
            }
            if(meter.name!==null&&meter.name!==undefined){
              this.meterName=meter.name
            }else{
              this.meterName="--"
            }
            if(meter.code!==null&&meter.code!==undefined){
              this.meterCode=meter.code
            }else{
              this.meterCode="--"
            }
            if(meter.strname!==null&&meter.strname!==undefined){
              this.meterType=meter.strname
            }else{
              this.meterType="--"
            }
            if(meter.balance!==null&&meter.balance!==undefined){
              this.meterBalance=meter.balance.toFixed(2)+" 元"
            }else{
              this.meterBalance="--"
            }
            if(meter.readingTime!==null&&meter.readingTime!==undefined){
              this.meterReadingTime=format(meter.readingTime,"YYYY-MM-DD HH:mm:ss")
            }else{
              this.meterReadingTime="--"
            }
          }
        }
      }
    },
    mounted() {
      this.queryUserInfo() //查询用户信息
        getMetersByUser(this.customerId,this.customerUserId).then(response => { //查询仪表信息
          this.meters=response.infoJson
          //获取路由参数
          let meterId = this.$route.query.meterId
          //赋值下拉框meterId
          if(meterId !==null && meterId !== undefined) {
            this.meterId = meterId
          }
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '仪表信息查询失败'
          })
        })
      //WebSocket
      this.rechargeSubscribe = new WS();
      this.rechargeSubscribe.connect(res => {
        this.rechargeSubscribe.subscribe("/topic/recharge/"+this.customerUserId, (val) => {//读取仪表参数订阅，若接收到内容，因报停调用的读取仪表参数内容更新信息
          let message=null
          if(val!==null&&val!==undefined&&val.body!==null&&val.body!==undefined){
            message=JSON.parse(val.body)
          }
          if(message!==null&&message!==undefined&&message.uuid!==null&&message.uuid!==undefined&&this.$store.getters.rechargeUUID[message.uuid]==message.uuid) {
            delete this.$store.getters.rechargeUUID[message.uuid]   //删除操作id
            let result = message.result
            if (result !== null && result !== undefined) {
              //整理数据
              let rechargeTime = "--"
              let userName = "--"
              let userCode = "--"
              let address = "--"
              let meterName = "--"
              let meterCode = "--"
              let meterNum = "--"
              let rechargeAmount = "--"
              let rechargeChannel = "--"
              let rechargeType = "--"
              let balance = "--"
              let preBalance = "--"
              let status = "--"
              let operateName = "--"
              let tradeNo = result.id
              if (result.string_time !== null && result.string_time !== undefined && result.string_time !== "") {
                rechargeTime = result.string_time
              }
              if (result.customer_user_name !== null && result.customer_user_name !== undefined && result.customer_user_name !== "") {
                userName = result.customer_user_name
              }
              if (result.customer_user_code !== null && result.customer_user_code !== undefined && result.customer_user_code !== "") {
                userCode = result.customer_user_code
              }
              if (result.address !== null && result.address !== undefined && result.address !== "") {
                address = result.address
              }
              if (result.meter_name !== null && result.meter_name !== undefined && result.meter_name !== "") {
                meterName = result.meter_name
              }
              if (result.meter_code !== null && result.meter_code !== undefined && result.meter_code !== "") {
                meterCode = result.meter_code
              }
              if (result.meter_num !== null && result.meter_num !== undefined && result.meter_num !== "") {
                meterNum = result.meter_num
              }
              if (result.recharge_amount !== null && result.recharge_amount !== undefined && result.recharge_amount !== "") {
                rechargeAmount = result.recharge_amount.toFixed(2)
              }
              if (result.channel_name !== null && result.channel_name !== undefined && result.channel_name !== "") {
                rechargeChannel = result.channel_name
              }
              if (result.type_name !== null && result.type_name !== undefined && result.type_name !== "") {
                rechargeType = result.type_name
              }
              if (result.balance !== null && result.balance !== undefined && result.balance !== "") {
                balance = result.balance.toFixed(2)
              }
              if (result.pre_balance !== null && result.pre_balance !== undefined && result.pre_balance !== "") {
                preBalance = result.pre_balance.toFixed(2)
              }
              if (result.status !== null && result.status !== undefined && result.status !== "") {
                if (result.status == 0) {
                  status = "支付中"
                  return
                } else if (result.status == 1 || result.status == 5) {
                  status = "充值中"
                  return
                } else if (result.status == 2) {
                  status = "充值成功"
                  // 重新查询仪表信息
                  getMetersByUser(this.customerId,this.customerUserId).then(response => {
                    this.meters = response.infoJson
                    // 当前仪表是回调仪表时，更新余额和抄表时间
                    if (this.meterId === result.meter_id) {
                        for (let i in response.infoJson) {
                          // 找到当前仪表
                          if (response.infoJson[i].id === result.meter_id) {
                            if (response.infoJson[i].balance !== null && response.infoJson[i].balance !== undefined) {
                              this.meterBalance = response.infoJson[i].balance.toFixed(2) + " 元"
                            }
                            if (response.infoJson[i].readingTime) {
                              this.meterReadingTime = response.infoJson[i].readingTime
                            }
                            break
                          }
                        }
                    }
                  }).catch(error => {

                  })
                } else if (result.status == 3) {
                  status = "支付失败"
                } else if (result.status == 4) {
                  status = "充值失败"
                }
              }
              if (result.operate_name !== null && result.operate_name !== undefined && result.operate_name !== "") {
                operateName = result.operate_name
              }
              //设置通知内容、类型
              let notifyType = "success"
              let notifyMessage = ""
              if (result.status == 2) {   //充值成功
                notifyMessage = "尊敬的" + userName + "(" + userCode + ")" + "，您的仪表" + meterName + "(" + meterCode + ")" + status + "，充值金额" + rechargeAmount + "元。"
              } else {
                notifyType = "error"
                notifyMessage = "尊敬的" + userName + "(" + userCode + ")" + "，您的仪表" + meterName + "(" + meterCode + ")" + status + "，请及时联系相关人员。"
              }
              //整理充值记录单内容
              let content=`<style type='text/css'>
                            .subtitle {text-align: center;font-size: 13px;font-weight: 600;margin-bottom: 2px;}
                            .title {text-align: center;font-size: 13px;margin-bottom: 10px;height: 23px;border-bottom: 1px dashed #999999;}
                            .content-bottom {border-top: 1px dashed #999999;margin-top:2px;}
                            .content-bottom-font{font-size: 9px;color: #464646;text-align: center;margin-top :7px;}
                            .name {width: 48%;float: left;text-align: right;padding-right: 2%;color: #464646;font-size: 10px;line-height: 15px;}
                            .value {width: 50%;float: left;font-size: 11px;line-height: 15px;white-space: normal;word-break: break-all;word-wrap: break-word;}
                         </style>
                         <div class='print'>
                            <div class='subtitle'>AcuBill网络预付费系统</div>
                            <div class='title'>充值记录单</div>
                            <div><div class='name'>充值单号:</div><div class='value'>` + tradeNo + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值时间:</div><div class='value'>` + rechargeTime + `</div><br style='clear:both;'></div>
                            <div><div class='name'>用户名称:</div><div class='value'>` + userName + `</div><br style='clear:both;'></div>
                            <div><div class='name'>用户编号:</div><div class='value'>` + userCode + `</div><br style='clear:both;'></div>
                            <div><div class='name'>用户地址:</div><div class='value'>` + address + `</div><br style='clear:both;'></div>
                            <div><div class='name'>仪表名称:</div><div class='value'>` + meterName + `</div><br style='clear:both;'></div>
                            <div><div class='name'>仪表编号:</div><div class='value'>` + meterCode + `</div><br style='clear:both;'></div>
                            <div><div class='name'>表号:</div><div class='value'>` + meterNum + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值金额(元):</div><div class='value'>` + rechargeAmount + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值渠道:</div><div class='value'>` + rechargeChannel + `</div><br style='clear:both;'></div>
                            <div><div class='name'>付款方式:</div><div class='value'>` + rechargeType + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值前余额(元):</div><div class='value'>` + preBalance + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值后余额(元):</div><div class='value'>` + balance + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值状态:</div><div class='value'>` + status + `</div><br style='clear:both;'></div>
                            <div><div class='name'>操作人:</div><div class='value'>` + operateName + `</div><br style='clear:both;'></div>
                            <div class='content-bottom'><div class='content-bottom-font'>请您妥善保管</div></div>
                         </div>`
              //通知
              this.$notify({
                title: status,
                type: notifyType,
                dangerouslyUseHTMLString: true,
                duration: 0,
                message: this.$createElement("div", null, [
                  this.$createElement("div", {
                    style: {
                      "margin-bottom": "5px",
                      "word-break": "break-all"
                    }
                  }, notifyMessage),
                  /*this.$createElement("button", {
                    on: {
                      click: function () {
                        //打印账单
                        let newWindow = window.open("about:blank")
                        newWindow.document.write(content)
                        newWindow.print();
                        newWindow.close();
                      }
                    },
                    attrs: {
                      class: "el-button el-button--primary"
                    }
                  }, "打印凭条"),*/
                  this.$createElement("button", {
                    on: {
                      click: function () {
                        if(result.email!==null&&result.email!==undefined&&result.email!==""){
                          sendMail(result.email,result.customer_name,"充值记录单",content,null).then(response => {
                            if(response.code==200){
                              this.$message({
                                type: 'success',
                                message: '邮件发送成功'
                              })
                            }else{
                              this.$message({
                                type: 'error',
                                message: '邮件发送失败'
                              })
                            }
                          }).catch(error => {
                            this.$message({
                              type: 'error',
                              message: '邮件发送失败'
                            })
                          })
                        }else{
                          this.$message({
                            type: 'error',
                            message: '该用户未设置电子邮箱'
                          })
                        }
                      }
                    },
                    attrs: {
                      class: "el-button el-button--primary"
                    }
                  }, "发送邮件")
                ])
              })
            }
          }
        })
      }, err => {

      })
    },
    destroyed(){
      // 清除订阅记录
      if (this.rechargeSubscribe && this.rechargeSubscribe.connected) {
        this.rechargeSubscribe.disconnect()
      }

    },
    methods: {
      pay() {   //支付
        let meterId=this.meterId
        if(meterId===null||meterId===undefined||meterId===""){
          this.$message({
            type: 'error',
            message: '请选择充值仪表'
          })
          return
        }
        let reg=/^([0-9]+|[0-9]{1,3}(,[0-9]{3})*)(.[0-9]{1,2})?$/;
        if(!reg.test(this.money)){
          this.$message({
            type: 'error',
            message: '请输入合理的充值金额'
          })
          return
        }else if(parseFloat(this.money)===0){
          this.$message({
            type: 'error',
            message: '请输入合理的充值金额'
          })
          return
        }
        if(this.meterStatus==false){    //判断通讯状态
          this.$message({
            type: 'error',
            message: '该仪表通信中断，无法充值'
          })
          return
        }
        // 每次点击支付时，先清空弹出框的图片、支付类型、订单号
        this.qrSrc=""
        this.payTypeName=""
        this.tradeNo=""
        // 生成订单号
        let tradeNo=this.randomString(10)+"-"+new Date().getTime()
        let commandId=uuidWithoutLine()
        if(this.payType === "wxpay"){
          // 加载遮罩
          this.fullscreenLoading = true;
          // 微信金额单位（分）,后台需乘100
          let amount=this.money
          wxPay(tradeNo,commandId,amount,meterId,this.customerId,this.customerUserId).then(res => {
            this.fullscreenLoading = false;
            if (res.code === 200) {
              this.qrSrc = res.infoJson.url
              this.realMoney = res.infoJson.realMoney
              this.moneyStr = parseFloat(this.money).toFixed(2)
              this.payTypeName="请使用微信扫码"
              this.tradeNo=tradeNo
              this.dialogVisible=true
              // 生成二维码
              this.$nextTick(() => {
                QRCode.toCanvas(document.querySelector('canvas'), this.qrSrc)
              })
              // 记录操作id
              this.$store.getters.rechargeUUID[commandId]=commandId
              // 轮询支付结果
              this.rechargeResult(tradeNo)
            } else {
              this.$message({
                type: 'error',
                message: res.message
              })
            }
          }).catch(error => {
            this.fullscreenLoading = false;
            this.$message({
              type: 'error',
              message: '二维码生成失败，请重试'
            })
          })
        }else if(this.payType === "alipay"){
          // 加载遮罩
          this.fullscreenLoading = true;
          // 支付宝金额单位（元）
          let amount=this.money
          aliPay(tradeNo,commandId,amount,meterId,this.customerId,this.customerUserId).then(res => {
            this.fullscreenLoading = false;
            if(res.code === 200){
              this.qrSrc = res.infoJson.url
              this.realMoney = res.infoJson.realMoney
              this.moneyStr = parseFloat(this.money).toFixed(2)
              this.payTypeName = "请使用支付宝扫码"
              this.tradeNo = tradeNo
              this.dialogVisible = true
              // 生成二维码
              this.$nextTick(() => {
                QRCode.toCanvas(document.querySelector('canvas'), this.qrSrc)
              })
              //记录操作id
              this.$store.getters.rechargeUUID[commandId]=commandId
              //轮询支付结果
              this.rechargeResult(tradeNo)
            }else{
              this.$message({
                type: 'error',
                message: res.message
              })
            }
          }).catch(error => {
            this.fullscreenLoading = false;
            this.$message({
              type: 'error',
              message: '二维码生成失败，请重试'
            })
          })
        }
      },
      /**
       * 轮询支付结果，目的为关闭二维码窗口
       * @param tradeNo
       */
      rechargeResult(tradeNo){
        let interval=setInterval(()=>{
          rechargeResult(tradeNo).then(response => {
            let result=response.infoJson
            if(result.status == 3){ //状态为“支付失败”，则判断是否关闭二维码窗口且给出提示
              //停止轮询
              clearInterval(interval)
              //删除操作id
              delete this.$store.getters.rechargeUUID[result.tradeNo]
              //订单号与页面相同时，关闭窗口，并清空图片、支付类型
              if(result.tradeNo==this.tradeNo){
                this.dialogVisible=false
                this.qrSrc=""
                this.payTypeName=""
              }
              //提示支付失败
              this.$message({
                type: 'error',
                message: '支付失败，订单号：'+tradeNo
              })
            }else if(result.status!=0){ //状态不为“支付中”，则判断是否关闭二维码窗口
              //停止轮询
              clearInterval(interval)
              //订单号与页面相同时，关闭窗口，并清空图片、支付类型
              if(result.tradeNo==this.tradeNo){
                this.dialogVisible=false
                this.qrSrc=""
                this.payTypeName=""
              }
            }
          }).catch(error => {
            })
        },5000)
        //超过1分钟停止轮询
        let timeout=setTimeout(()=>{
          clearInterval(interval)
          clearTimeout(timeout)
        },60000)
      },
      /**
       * 查询用户信息
       */
      queryUserInfo() {
        queryCustomerById(this.customerUserId).then(response => {
          let user=response.infoJson
          if(user !== null && user!==undefined){
            if(user.realName !== null && user.realName !== undefined && user.realName !==""){
              this.customerName=user.realName
            }else{
              this.customerName="--"
            }
            if(user.name !== null && user.name !== undefined && user.name !==""){
              this.customerCode=user.name
            }else{
              this.customerCode="--"
            }
            if(user.mobile !== null && user.mobile !== undefined && user.mobile !==""){
              this.customerMobile=user.mobile
            }else{
              this.customerMobile="--"
            }
            if(user.address !== null && user.address !== undefined && user.address !==""){
              this.customerAddr=user.address
            }else{
              this.customerAddr="--"
            }
            if(user.email !== null && user.email !== undefined && user.email !==""){
              this.customerEmail=user.email
            }else{
              this.customerEmail="--"
            }
            if(user.contactPerson !== null && user.contactPerson !== undefined && user.contactPerson !==""){
              this.customerContactPerson=user.contactPerson
            }else{
              this.customerContactPerson="--"
            }
          }else{
            this.$message({
              type: 'error',
              message: '用户信息查询失败'
            })
          }
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '用户信息查询失败'
          })
        })
      },
      /**
       * 生成随机字符串
       * @param len
       * @returns {string}
       */
      randomString(len){
        len = len || 32;
        var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        var maxPos = $chars.length;
        var pwd = '';
        for (var i = 0; i < len; i++) {
          pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
      }
    }
  }
</script>

<style scoped>
    .el-col{
        line-height: 40px;
    }
    .el-col-24{
        font-size: 15px;
        font-weight: 600;
    }
    .left{
        position: absolute;
        left: 0;
        top: 40px;
        bottom: 0;
        width:26%;
        height:calc(95% - 40px);
        background-color: #ffffff;
        border-radius: 4px;
        overflow: auto;
    }
    .left-flex{
        display:flex;
        flex-direction: column;
        height:calc(100% - 20px);
        width:calc(100% - 40px);
        margin: 10px 10px 10px 30px;
        font-size: 14px;
    }
    .right{
        position: absolute;
        left: 29%;
        top: 40px;
        bottom: 0;
        width:71%;
        height:calc(95% - 40px);
        background-color: #ffffff;
        border-radius: 4px;
        overflow: auto;
    }
    .right-flex{
        display:flex;
        flex-direction: column;
        height:calc(100% - 180px);
        width:calc(100% - 40px);
        margin: 10px 10px 10px 30px;
    }
    .right-flex>.el-row{
        flex:1 1 auto;
    }
    .el-radio{
        width: 90%;
    }
    .left-head{
        position: absolute;
        left: 0;
        width:26%;
    }
    .right-head{
        position: absolute;
        left: 29%;
        width:71%;
    }
    .title-card{
        line-height: 40px;
        font-weight: normal;
        font-size: 15px;
        color: #6A6A6A;
    }
    .meter{
        background-color: #F6F6F6;
        border-radius: 4px;
        margin-top: 5px;
        font-size: 14px;
    }
    .amount-input{
        width: 70%;
    }
    .userInfo{
        color:#6A6A6A;
        font-size: 14px;
    }
    .userInfoValue{
        font-size: 18px;
        color:black;
        word-break: break-all;
    }
    .dialogInfo{
        line-height: 20px;
        word-break: break-all;
    }
    .qrcode_box {
        width: 300px !important;
        height: 300px !important;
        margin: 0 auto;
    }
    .qrcode {
        width: 300px !important;
        height: 300px !important;
    }
</style>
<style>
    .el-dialog {
        background: #f6f7f7 !important;
    }
</style>
